import React from 'react';

/* ── Constants ────────────────────────────────────────────── */

export const MAX_RECORDING_SECONDS = 180;

/** Minimum flash duration; scales up for longer transcripts. */
const TRANSCRIPT_FLASH_MS_BASE = 1800;
const TRANSCRIPT_FLASH_MS_PER_CHAR = 12;
const TRANSCRIPT_FLASH_MS_MAX = 4000;

export function transcriptFlashMs(text: string): number {
  return Math.min(TRANSCRIPT_FLASH_MS_MAX, TRANSCRIPT_FLASH_MS_BASE + text.length * TRANSCRIPT_FLASH_MS_PER_CHAR);
}

/* ── Types ────────────────────────────────────────────────── */

export type InteractionMode = 'tap' | 'hold';

/* ── Sub-components ───────────────────────────────────────── */

/** Five animated bars that pulse while the mic is live. */
export function Waveform() {
  return (
    <div className="voice-bar-waveform" aria-hidden="true">
      <div className="voice-bar-waveform-bar" />
      <div className="voice-bar-waveform-bar" />
      <div className="voice-bar-waveform-bar" />
      <div className="voice-bar-waveform-bar" />
      <div className="voice-bar-waveform-bar" />
    </div>
  );
}

/** Tap / Hold mode toggle rendered outside narrowed-type blocks to avoid TS2367. */
export function ModeToggle({ current, onChange }: { current: InteractionMode; onChange: (m: InteractionMode) => void }) {
  return (
    <div className="voice-bar-mode-toggle">
      <button
        className={`voice-bar-mode-btn${current === 'tap' ? ' active' : ''}`}
        onClick={() => onChange('tap')}
        aria-label="Tap to talk mode"
      >
        Tap
      </button>
      <button
        className={`voice-bar-mode-btn${current === 'hold' ? ' active' : ''}`}
        onClick={() => onChange('hold')}
        aria-label="Hold to talk mode"
      >
        Hold
      </button>
    </div>
  );
}
